<template>
  <el-dialog
    v-if="canEditPayment"
    :title="title"
    :visible.sync="state.dialog.show"
    v-on:close="onClose"
  >
    <form>
      <div class="row">
        <div class="col">
          <base-input
            label="Existing Donor"
          >
            <key-value-suggest
              v-model="model.donorId"
              keyProperty="id" valueProperty="name"
              :data="state.donorList"
              placeholder="Pick a donor"
            ></key-value-suggest>
          </base-input>
        </div>
        <div class="col">
          <base-input
            label="Name"
            v-model="model.name"
            placeholder="John Doe"
            :disabled="false"
            id="name" v-on:blur="$v.validateEvent($event)" :valid="$v.model.name" :error="$v.error.name"
          ></base-input>
          <base-input
            label="Email"
            v-model="model.email"
            placeholder="john@example.com"
            :disabled="false"
            id="email" v-on:blur="$v.validateEvent($event)" :valid="$v.model.email" :error="$v.error.email"
          ></base-input>

        </div>
      </div>
      <hr/>
      <div class="row">
        <div class="col">
          <base-input
            label="Date"
            :valid="$v.model.date" :error="$v.error.date"
          >
            <el-date-picker
              v-model="model.dtc"
              type="date" value-format="yyyy-MM-dd"
              placeholder="Payment date"
              :blur="$v.validateProperty('date', model.dtc)" 
            ></el-date-picker>
          </base-input>
        </div>
        <div class="col">
          <base-input
            label="Cause"
            :valid="$v.model.cause" :error="$v.error.cause"
          >
            <key-value-suggest
              v-model="model.causeId"
              keyProperty="id" valueProperty="name"
              :data="state.causeList"
              placeholder="Pick a cause"
              :blur="$v.validateProperty('cause', model.causeId)"
            ></key-value-suggest>
          </base-input>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <base-input
            label="Amount"
            v-model="model.amount"
            placeholder="0.00"
            id="amount" v-on:blur="$v.validateEvent($event)" :valid="$v.model.amount" :error="$v.error.amount"
          ></base-input>
        </div>
        <div class="col">
          <base-input
            label="Bank Fee"
            v-model="model.bankFee"
            placeholder="0.00"
            id="bankFee" v-on:blur="$v.validateEvent($event)" :valid="$v.model.bankFee" :error="$v.error.bankFee"
          ></base-input>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <base-input
            label="Currency"
            v-model="model.currency"
            id="currency" v-on:blur="$v.validateEvent($event)" :valid="$v.model.currency" :error="$v.error.currency"
          ></base-input>
        </div>
      </div>

    </form>
    <span slot="footer" class="dialog-footer">
      <button class="btn mr-2" @click="onEditPaymentCancel">Cancel</button>
      <button class="btn btn-primary btn-fill" type="primary" @click="onEditPaymentConfirm">Ok</button>
    </span>
  </el-dialog>
</template>
<script>
import { computed, reactive, ref, onMounted, watch } from '@vue/composition-api'
import { What, Verb, can }  from '@/rights/rights.js'
import graphql from '@/api/graphql'
import gql from 'graphql-tag'
import { useValidator } from 'src/components/validator.js'
import BaseInput from '@/components/Forms/BaseInput.vue'
import BaseSelect from '@/components/Forms/BaseSelect.vue'
import KeyValueSuggest from '@/components/Forms/KeyValueSuggest.vue'

export default {
  components: {
    BaseInput,
    BaseSelect,
    KeyValueSuggest
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: "Edit Payment"
    },
    value: {
      type: Object
    }
  },
  setup(props, context) {
    const store = context.root.$store

    const state = reactive({
      causeList: [],
      donorList: [],
      dialog: {
        show: false
      }
    })

    const model = reactive({
    })

    watch(
      () => props.show,
      (to, from) => {
      // console.log('show changed', to, from)
      state.dialog.show = to
      refreshLists()
      if (to) {
        refreshModel()
      }
    })

    function refreshModel() {
      for (const property in model) {
        model[property] = props.value[property]
      }
    }

    function refreshLists() {
      let graphQuery = gql`query PaymentDialog {
        causeList {
          id
          name
        }
        donorList {
          id
          name
        }
      }`
      graphql.query(graphQuery, {})
      .then(json => {
        state.causeList = json.data.causeList
        state.donorList = json.data.donorList
      })
      .catch(gqlResponse => {
        graphql.handleError(gqlResponse, 'Error getting dialog data:', store.dispatch)
      })
    }

    const canEditPayment = computed(() => {
      return can(Verb.EDIT, What.PAYMENT, {})
    })

    const $v = useValidator({
      //     function(value, attributes, attributeName, options, constraints)
      email: function() {
        if (!model.donorId) {
          return {
            email: true
          }
        }
        return undefined
      },
      name: function() {
        if (!model.donorId) {
          return {
            length: { minimum: 3 }
          }
        }
        return undefined
      },
      date: {
        presence: true
      },
      cause: {
        presence: true
      },
      amount: {
        numericality: {
          greaterThanOrEqualTo: 0
        }
      },
      bankFee: {
        numericality: {
          greaterThanOrEqualTo: 0
        }
      },
      currency: {
        length: { is: 3 }
      },
    })

    function onEditPaymentCancel() {
      state.dialog.show = false
    }

    function onEditPaymentConfirm() {
      const isValid = $v.validateAll(model)
      if (isValid) {
        context.emit('input', model)
      }
      state.dialog.show = false
    }

    function onClose() {
      context.emit("update:show", false)
    }

    return {
      model,
      state,
      $v,
      canEditPayment,
      onEditPaymentCancel,
      onEditPaymentConfirm,
      onClose
    }
  }
}
</script>
